import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cart/cartSlice";
import { createSlice } from "@reduxjs/toolkit";
export const store = configureStore({
  reducer: {
    cart: cartSlice,
  },
});